(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7616],{

/***/ 53839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ signup; }
});

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(17160);
// EXTERNAL MODULE: ./components/Layouts/Main/index.tsx + 8 modules
var Main = __webpack_require__(58204);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/axios/index.js
var axios = __webpack_require__(89644);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ../../node_modules/jotai/esm/react.mjs
var esm_react = __webpack_require__(752);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(62350);
// EXTERNAL MODULE: ./utils/api.ts + 1 modules
var api = __webpack_require__(74457);
;// CONCATENATED MODULE: ./hooks/mutations/auth/useSignUp.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var signUp = function signUp(_ref) {
  var name = _ref.name,
      password = _ref.password,
      email = _ref.email,
      company = _ref.company,
      phone = _ref.phone,
      position = _ref.position,
      isMarketingPolicyAccepted = _ref.isMarketingPolicyAccepted,
      acquisitionPath = _ref.acquisitionPath;
  return api/* api.post */.h.post('/auth/signup', {
    name: name,
    password: password,
    email: email,
    company: company,
    phone: phone,
    position: position,
    isMarketingPolicyAccepted: isMarketingPolicyAccepted,
    acquisitionPath: acquisitionPath
  });
};

var useSignUp = function useSignUp(options) {
  return (0,useMutation/* useMutation */.D)(signUp, _objectSpread({}, options));
};

/* harmony default export */ var auth_useSignUp = (useSignUp);
// EXTERNAL MODULE: ./state/user/atom.ts
var atom = __webpack_require__(37271);
// EXTERNAL MODULE: ./constants/formValidations.ts
var formValidations = __webpack_require__(65118);
;// CONCATENATED MODULE: ./constants/layout.ts
var URLS = {
  landingPage: '/',
  pricingPage: '/pricing',
  applyEarlyAccessPage: '/apply-early-access/essential',
  privacyPolicyPage: 'https://codestates.notion.site/salesclue-privacy',
  termsOfServicePage: 'https://codestates.notion.site/salesclue-policy',
  recruitmentInformationPage: 'https://codestates.career.greetinghr.com/home'
};
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
;// CONCATENATED MODULE: ./components/SignUp/CheckBox/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "ekzsuxa2"
} : 0)("border:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_200;
}, ";border-radius:8px;" + ( true ? "" : 0));
var BorderLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ekzsuxa1"
} : 0)("border-bottom:1px solid ", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.zinc_200;
}, ";" + ( true ? "" : 0));
var CheckBoxInput = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("input",  true ? {
  target: "ekzsuxa0"
} : 0)( true ? {
  name: "1djxupe",
  styles: "width:14px;height:14px"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/SignUp/CheckBox/index.tsx


function CheckBox_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CheckBox_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CheckBox_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CheckBox_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var CheckBox = function CheckBox(_ref) {
  var register = _ref.register,
      getValues = _ref.getValues,
      setValue = _ref.setValue;

  var handleTotalAgreeChange = function handleTotalAgreeChange(e) {
    if (e.target.checked) {
      setValue('isDefaultAgree', true);
      setValue('isMarketingPolicyAccepted', true);
    } else {
      setValue('isDefaultAgree', false);
      setValue('isMarketingPolicyAccepted', false);
    }
  };

  var handleDefaultAgreeChange = function handleDefaultAgreeChange(e) {
    if (e.target.checked && getValues('isMarketingPolicyAccepted')) {
      setValue('isTotalAgree', true);
    } else {
      setValue('isTotalAgree', false);
    }
  };

  var handleMarketingPolicyAcceptedChange = function handleMarketingPolicyAcceptedChange(e) {
    if (e.target.checked && getValues('isDefaultAgree')) {
      setValue('isTotalAgree', true);
    } else {
      setValue('isTotalAgree', false);
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
    gap: 8,
    direction: "column",
    padding: 16,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "sm-semibold",
      as: "label",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 8,
        alignItems: "center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckBoxInput, CheckBox_objectSpread({
          type: "checkbox"
        }, register('isTotalAgree', {
          onChange: handleTotalAgreeChange
        }))), "\uC804\uCCB4 \uB3D9\uC758\uD558\uAE30"]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BorderLine, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "sm-semibold",
      as: "label",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 8,
        alignItems: "center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckBoxInput, CheckBox_objectSpread({
          type: "checkbox"
        }, register('isDefaultAgree', {
          required: '필수 동의 약관입니다',
          onChange: handleDefaultAgreeChange
        }))), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            target: "_blank",
            href: URLS.privacyPolicyPage,
            rel: "noreferrer",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "sm-semibold",
              color: "skyblue_400",
              children: "\uAC1C\uC778\uC815\uBCF4 \uCC98\uB9AC \uBC29\uCE68"
            })
          }), "\uC744 \uD655\uC778\uD558\uACE0 \uB3D9\uC758\uD569\uB2C8\uB2E4 \xA0", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "sm-semibold",
            color: "skyblue_500",
            children: "(\uD544\uC218)"
          })]
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "sm-semibold",
      color: "zinc_400",
      as: "label",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 8,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckBoxInput, CheckBox_objectSpread({
          type: "checkbox"
        }, register('isMarketingPolicyAccepted', {
          onChange: handleMarketingPolicyAcceptedChange
        }))), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: ["\uC5C5\uB370\uC774\uD2B8 \uC18C\uC2DD, \uD504\uB85C\uBAA8\uC158 \uC774\uBCA4\uD2B8 \uB4F1\uC758 \uB9C8\uCF00\uD305 \uBAA9\uC801\uC758", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), " \uC218\uC2E0\uC744 \uB3D9\uC758\uD569\uB2C8\uB2E4 (\uC120\uD0DD)"]
        })]
      })
    })]
  });
};

/* harmony default export */ var SignUp_CheckBox = (CheckBox);
// EXTERNAL MODULE: ../../packages/styles/index.ts + 3 modules
var styles = __webpack_require__(97223);
;// CONCATENATED MODULE: ./components/SignUp/Form/index.styles.ts



function index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("form",  true ? {
  target: "e19d3wqa1"
} : 0)( true ? {
  name: "klisov",
  styles: "display:flex;flex-direction:column;gap:24px"
} : 0);
var Select = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("select",  true ? {
  target: "e19d3wqa0"
} : 0)("display:flex;width:", function (_ref) {
  var width = _ref.width;
  return width || '100%';
}, ";flex-direction:column;align-items:center;justify-content:center;padding:", function (_ref2) {
  var _ref2$paddingY = _ref2.paddingY,
      paddingY = _ref2$paddingY === void 0 ? 8 : _ref2$paddingY,
      _ref2$paddingX = _ref2.paddingX,
      paddingX = _ref2$paddingX === void 0 ? 16 : _ref2$paddingX;
  return "".concat(paddingY, "px ").concat(paddingX, "px");
}, ";margin:", function (_ref3) {
  var _ref3$marginTop = _ref3.marginTop,
      marginTop = _ref3$marginTop === void 0 ? 0 : _ref3$marginTop,
      _ref3$marginRight = _ref3.marginRight,
      marginRight = _ref3$marginRight === void 0 ? 0 : _ref3$marginRight,
      _ref3$marginBottom = _ref3.marginBottom,
      marginBottom = _ref3$marginBottom === void 0 ? 0 : _ref3$marginBottom,
      _ref3$marginLeft = _ref3.marginLeft,
      marginLeft = _ref3$marginLeft === void 0 ? 0 : _ref3$marginLeft;
  return "".concat(marginTop, "px ").concat(marginRight, "px ").concat(marginBottom, "px ").concat(marginLeft, "px");
}, ";border-radius:", function (_ref4) {
  var _ref4$radius = _ref4.radius,
      radius = _ref4$radius === void 0 ? 4 : _ref4$radius;
  return "".concat(radius, "px");
}, ";appearance:none;", function (_ref5) {
  var _ref5$textVariant = _ref5.textVariant,
      textVariant = _ref5$textVariant === void 0 ? 'md-regular' : _ref5$textVariant;

  var _textVariant$split = textVariant.split('-'),
      _textVariant$split2 = (0,slicedToArray/* default */.Z)(_textVariant$split, 2),
      sizeKey = _textVariant$split2[0],
      weightKey = _textVariant$split2[1];

  return "\n      font-size: ".concat(styles/* theme.fontSize */.rS.fontSize[sizeKey], ";\n      line-height: ").concat(styles/* theme.lineHeight */.rS.lineHeight[sizeKey], ";\n      font-weight: ").concat(styles/* theme.fontWeight */.rS.fontWeight[weightKey], ";\n    ");
}, " background-color:", function (_ref6) {
  var isError = _ref6.isError;
  return isError ? styles/* theme.colors.cerise_50 */.rS.colors.cerise_50 : styles/* theme.colors.zinc_50 */.rS.colors.zinc_50;
}, ";color:", styles/* theme.colors.zinc_500 */.rS.colors.zinc_500, ";border:1px solid ", function (_ref7) {
  var isError = _ref7.isError;
  return isError ? styles/* theme.colors.cerise_500 */.rS.colors.cerise_500 : styles/* theme.colors.zinc_200 */.rS.colors.zinc_200;
}, ";&::placeholder{color:", styles/* theme.colors.zinc_400 */.rS.colors.zinc_400, ";font-weight:300;}&:focus{outline:none;border-color:", styles/* theme.colors.skyblue_500 */.rS.colors.skyblue_500, ";}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./components/SignUp/Form/LabelText/index.tsx



var LabelText = function LabelText(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
    as: "p",
    color: "zinc_400",
    variant: "sm-regular",
    marginBottom: 8,
    children: children
  });
};

/* harmony default export */ var Form_LabelText = (LabelText);
;// CONCATENATED MODULE: ./hooks/mutations/auth/useCheckEmailAuthCode.ts


function useCheckEmailAuthCode_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useCheckEmailAuthCode_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useCheckEmailAuthCode_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useCheckEmailAuthCode_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var checkEmailAuthCode = function checkEmailAuthCode(_ref) {
  var code = _ref.code;
  return api/* api.get */.h.get('/auth/email', {
    params: {
      code: code
    }
  });
};

var useCheckEmailAuthCode = function useCheckEmailAuthCode(options) {
  return (0,useMutation/* useMutation */.D)(checkEmailAuthCode, useCheckEmailAuthCode_objectSpread({}, options));
};

/* harmony default export */ var auth_useCheckEmailAuthCode = (useCheckEmailAuthCode);
;// CONCATENATED MODULE: ./hooks/mutations/auth/useMakeUserEmailAuthCode.ts


function useMakeUserEmailAuthCode_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useMakeUserEmailAuthCode_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useMakeUserEmailAuthCode_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useMakeUserEmailAuthCode_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var makeUserEmailAuthCode = function makeUserEmailAuthCode(_ref) {
  var email = _ref.email;
  return api/* api.post */.h.post('/auth/email', {
    email: email
  });
};

var useGetUserEmailAuthCode = function useGetUserEmailAuthCode(options) {
  return (0,useMutation/* useMutation */.D)(makeUserEmailAuthCode, useMakeUserEmailAuthCode_objectSpread({}, options));
};

/* harmony default export */ var useMakeUserEmailAuthCode = (useGetUserEmailAuthCode);
;// CONCATENATED MODULE: ./components/SignUp/Form/useHandleTimer.ts


var useHandleTimer = function useHandleTimer(_ref) {
  var totalTime = _ref.totalTime;

  var _useState = (0,react.useState)(false),
      isTimerWork = _useState[0],
      setIsTimerWork = _useState[1];

  var _useState2 = (0,react.useState)(totalTime),
      time = _useState2[0],
      setTime = _useState2[1];

  var timerRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    if (isTimerWork) {
      timerRef.current = window.setInterval(function () {
        setTime(function (prev) {
          if (prev <= 0) {
            if (timerRef.current) {
              clearInterval(timerRef.current);
            }

            setIsTimerWork(false);
            return 0;
          }

          return prev - 1;
        });
      }, 1000);
    }

    return function () {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [isTimerWork]);

  var handleTimerStart = function handleTimerStart() {
    setIsTimerWork(true);
  };

  var handleTimerEnd = function handleTimerEnd() {
    setIsTimerWork(false);
  };

  var handleTimerInit = function handleTimerInit() {
    setTime(totalTime);
  };

  return {
    time: time,
    handleTimerStart: handleTimerStart,
    handleTimerEnd: handleTimerEnd,
    handleTimerInit: handleTimerInit
  };
};

/* harmony default export */ var Form_useHandleTimer = (useHandleTimer);
;// CONCATENATED MODULE: ./components/SignUp/Form/useCheckUserEmail.tsx






var VALID_TIME = 30;

var useCheckUserEmail = function useCheckUserEmail() {
  var _useState = (0,react.useState)(''),
      authCode = _useState[0],
      setAuthCode = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isAuthCodeInputVisible = _useState2[0],
      setIsAuthCodeInputVisible = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isAuthCodeInputEditable = _useState3[0],
      setIsAuthCodeInputEditable = _useState3[1];

  var _useState4 = (0,react.useState)(''),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isAuthCodeChecked = _useState5[0],
      setIsAuthCodeChecked = _useState5[1];

  var _useState6 = (0,react.useState)('입력한 이메일로 인증코드 받기'),
      authButtonMessage = _useState6[0],
      setAuthButtonMessage = _useState6[1];

  var toast = (0,src/* useToast */.pm)();

  var _useMakeUserEmailAuth = useMakeUserEmailAuthCode(),
      makeUserEmailCode = _useMakeUserEmailAuth.mutate;

  var _useCheckEmailAuthCod = auth_useCheckEmailAuthCode(),
      checkEmailAuthCode = _useCheckEmailAuthCod.mutate;

  var _useHandleTimer = Form_useHandleTimer({
    totalTime: VALID_TIME * 60
  }),
      time = _useHandleTimer.time,
      handleTimerStart = _useHandleTimer.handleTimerStart,
      handleTimerEnd = _useHandleTimer.handleTimerEnd,
      handleTimerInit = _useHandleTimer.handleTimerInit;

  var isAuthCodeClickable = (0,react.useMemo)(function () {
    return isAuthCodeInputEditable && authCode.length === 6;
  }, [isAuthCodeInputEditable, authCode]);

  var _useMemo = (0,react.useMemo)(function () {
    return [Math.floor(time / 60), Math.floor(time % 60) === 0 ? '00' : Math.floor(time % 60)];
  }, [time]),
      minutes = _useMemo[0],
      seconds = _useMemo[1];

  var handleGetCodeButtonClick = function handleGetCodeButtonClick(email) {
    makeUserEmailCode({
      email: email
    }, {
      onSuccess: function onSuccess() {
        setIsAuthCodeInputVisible(true);
        setIsAuthCodeInputEditable(true);
        setIsAuthCodeChecked(false);
        setAuthButtonMessage('다시 메일로 인증코드 받기');
        handleTimerInit();
        handleTimerStart();
        toast('입력하신 이메일로 인증번호를 보냈습니다!');
      },
      onError: function onError(error) {
        var _error$response;

        if (axios_default().isAxiosError(error) && (_error$response = error.response) !== null && _error$response !== void 0 && _error$response.data) {
          var status = error.response.status;

          if (status === 409) {
            toast.error('이미 가입한 이메일입니다. 다른 계정으로 시도해주세요');
          }
        }
      }
    });
  };

  var handleAuthCodeConfirmClick = function handleAuthCodeConfirmClick() {
    if (!isNaN(Number(authCode)) && authCode.length === 6) {
      checkEmailAuthCode({
        code: Number(authCode)
      }, {
        onSuccess: function onSuccess() {
          setIsAuthCodeChecked(true);
          setIsAuthCodeInputVisible(false);
          setAuthButtonMessage('이메일 인증 완료');
          handleTimerEnd();
        },
        onError: function onError(error) {
          var _error$response2;

          if (axios_default().isAxiosError(error) && (_error$response2 = error.response) !== null && _error$response2 !== void 0 && _error$response2.data) {
            var status = error.response.status;

            if (status === 400) {
              setErrorMessage('코드가 일치하지 않습니다');
              return;
            }

            if (status === 410) {
              setErrorMessage('코드가 만료되었습니다');
            }
          }
        }
      });
    }
  };

  (0,react.useEffect)(function () {
    if (time === 0 && !isAuthCodeChecked) {
      setIsAuthCodeInputEditable(false);
      toast.error('이메일 인증 시간이 초과되었습니다! 인증코드 받기 버튼을 다시 클릭해주세요!');
    }
  }, [time]);
  return {
    handleAuthCodeConfirmClick: handleAuthCodeConfirmClick,
    handleGetCodeButtonClick: handleGetCodeButtonClick,
    isAuthCodeInputVisible: isAuthCodeInputVisible,
    isAuthCodeChecked: isAuthCodeChecked,
    isAuthCodeInputEditable: isAuthCodeInputEditable,
    isAuthCodeClickable: isAuthCodeClickable,
    authCode: authCode,
    time: time,
    minutes: minutes,
    seconds: seconds,
    errorMessage: errorMessage,
    authButtonMessage: authButtonMessage,
    setAuthCode: setAuthCode
  };
};

/* harmony default export */ var Form_useCheckUserEmail = (useCheckUserEmail);
;// CONCATENATED MODULE: ./components/SignUp/Form/index.tsx





function Form_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Form_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Form_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Form_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var Form = function Form() {
  var router = (0,next_router.useRouter)();

  var _useForm = (0,index_esm/* useForm */.cI)({
    mode: 'onChange',
    defaultValues: {
      phoneNumber1: '010'
    }
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      watch = _useForm.watch,
      setFocus = _useForm.setFocus,
      setValue = _useForm.setValue,
      getValues = _useForm.getValues,
      _useForm$formState = _useForm.formState,
      errors = _useForm$formState.errors,
      isValid = _useForm$formState.isValid;

  var _useSignUp = auth_useSignUp(),
      mutateAsync = _useSignUp.mutateAsync;

  var _React$useState = react.useState(''),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      signUpErrorMessage = _React$useState2[0],
      setSignUpErrorMessage = _React$useState2[1];

  var setUserInfo = (0,esm_react/* useSetAtom */.b9)(atom/* userInfoAtom */.w);
  var password = watch('password', '');
  var phoneNumber1 = watch('phoneNumber1', '010');
  var phoneNumber2 = watch('phoneNumber2', '');
  var acquisitionPath = watch('acquisitionPath', '');

  var _useCheckUserEmail = Form_useCheckUserEmail(),
      minutes = _useCheckUserEmail.minutes,
      seconds = _useCheckUserEmail.seconds,
      authCode = _useCheckUserEmail.authCode,
      setAuthCode = _useCheckUserEmail.setAuthCode,
      errorMessage = _useCheckUserEmail.errorMessage,
      authButtonMessage = _useCheckUserEmail.authButtonMessage,
      isAuthCodeChecked = _useCheckUserEmail.isAuthCodeChecked,
      isAuthCodeClickable = _useCheckUserEmail.isAuthCodeClickable,
      isAuthCodeInputEditable = _useCheckUserEmail.isAuthCodeInputEditable,
      isAuthCodeInputVisible = _useCheckUserEmail.isAuthCodeInputVisible,
      handleAuthCodeConfirmClick = _useCheckUserEmail.handleAuthCodeConfirmClick,
      handleGetCodeButtonClick = _useCheckUserEmail.handleGetCodeButtonClick;

  var toast = (0,src/* useToast */.pm)();
  react.useEffect(function () {
    if (phoneNumber1.length === 3) {
      setFocus('phoneNumber2');
    }
  }, [phoneNumber1]);
  react.useEffect(function () {
    if (phoneNumber2.length === 4) {
      setFocus('phoneNumber3');
    }
  }, [phoneNumber2]);
  react.useEffect(function () {
    setFocus('email');
  }, []);

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      var email, name, company, position, acquisitionPath, acquisitionPathEtc, request, response, _error$response, _ref2, message;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (isAuthCodeChecked) {
                _context.next = 3;
                break;
              }

              toast.error('이메일 인증을 완료해 주세요');
              return _context.abrupt("return");

            case 3:
              email = data.email, name = data.name, company = data.company, position = data.position, acquisitionPath = data.acquisitionPath, acquisitionPathEtc = data.acquisitionPathEtc;
              request = Form_objectSpread(Form_objectSpread({}, data), {}, {
                email: email.trim(),
                name: name.trim(),
                company: company.trim(),
                position: position.trim(),
                phone: "".concat(data.phoneNumber1).concat(data.phoneNumber2).concat(data.phoneNumber3),
                acquisitionPath: acquisitionPath === '기타' ? "\uAE30\uD0C0: ".concat((acquisitionPathEtc === null || acquisitionPathEtc === void 0 ? void 0 : acquisitionPathEtc.trim()) || '') : acquisitionPath
              });
              _context.prev = 5;
              _context.next = 8;
              return mutateAsync(request);

            case 8:
              response = _context.sent;
              setUserInfo(response.data.data.user);
              setSignUpErrorMessage(''); // 구글 애즈 전환 이벤트 트래킹

              if (window.gtag) {
                window.gtag('event', 'conversion', {
                  send_to: 'AW-17176230763/Qy-RCKOti9kaEOv2of4_'
                });
              }

              router.push('/user/pdf');
              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](5);

              if (axios_default().isAxiosError(_context.t0) && (_error$response = _context.t0.response) !== null && _error$response !== void 0 && _error$response.data) {
                _ref2 = _context.t0.response.data, message = _ref2.message;
                setSignUpErrorMessage(message);
              }

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 15]]);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var getPhoneNumberErrorMessage = function getPhoneNumberErrorMessage() {
    if (errors.phoneNumber1) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
        errors: errors,
        name: "phoneNumber1"
      });
    }

    if (errors.phoneNumber2) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
        errors: errors,
        name: "phoneNumber2"
      });
    }

    if (errors.phoneNumber3) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
        errors: errors,
        name: "phoneNumber3"
      });
    }

    return null;
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
    onSubmit: handleSubmit(onSubmit),
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      gap: 16,
      direction: "column",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Form_LabelText, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "sm-medium",
              children: "\uC5C5\uBB34\uC6A9 \uC774\uBA54\uC77C \xA0"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "sm-medium",
              color: "skyblue_500",
              children: "*\uD544\uC218"
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, Form_objectSpread(Form_objectSpread({
            type: "text",
            placeholder: "example@example.com",
            isError: Boolean(errors.email)
          }, register('email', {
            required: formValidations/* FORM_VALIDATIONS.email.required */.R.email.required,
            pattern: {
              value: formValidations/* FORM_VALIDATIONS.email.pattern.value */.R.email.pattern.value,
              message: formValidations/* FORM_VALIDATIONS.email.pattern.message */.R.email.pattern.message
            }
          })), {}, {
            disabled: isAuthCodeChecked
          }))]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
          errors: errors,
          name: "email"
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
        type: "button",
        variant: "skyblue_400_fill",
        disabled: isAuthCodeChecked,
        onClick: function onClick() {
          handleGetCodeButtonClick(getValues('email'));
        },
        children: authButtonMessage
      })]
    }), isAuthCodeInputVisible && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      gap: 16,
      direction: "column",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Form_LabelText, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "sm-medium",
            children: "\uC778\uC99D\uCF54\uB4DC \xA0"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, {
          type: "string",
          placeholder: "\uC778\uC99D\uCF54\uB4DC 6\uC790\uB9AC\uB97C \uC785\uB825\uD558\uC138\uC694",
          value: authCode,
          onChange: function onChange(e) {
            return setAuthCode(e.target.value);
          },
          disabled: !isAuthCodeInputEditable
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
        justifyContent: "space-between",
        alignItems: "center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            color: "zinc_400",
            variant: "md-regular",
            children: "".concat(String(minutes).padStart(2, '0'), " : ").concat(String(seconds).padStart(2, '0'))
          }), !isAuthCodeChecked && errorMessage !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            color: "cerise_300",
            variant: "md-regular",
            paddingLeft: 8,
            children: errorMessage
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
          type: "button",
          variant: "skyblue_400_fill",
          onClick: handleAuthCodeConfirmClick,
          disabled: !isAuthCodeClickable,
          children: "\uD655\uC778"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Form_LabelText, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "sm-medium",
            children: "\uC774\uB984 \uD639\uC740 \uB2C9\uB124\uC784 \xA0"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "sm-medium",
            color: "skyblue_500",
            children: "*\uD544\uC218"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, Form_objectSpread(Form_objectSpread({
          type: "text",
          placeholder: "\uAE40\uC720\uC800",
          isError: Boolean(errors.name)
        }, register('name', {
          required: '이름 혹은 닉네임을 입력해주세요.'
        })), {}, {
          maxLength: 10
        }))]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
        errors: errors,
        name: "name"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Form_LabelText, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "sm-medium",
            children: "\uBE44\uBC00\uBC88\uD638 \xA0"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "sm-medium",
            color: "skyblue_500",
            children: "*\uD544\uC218"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, Form_objectSpread({
          type: "password",
          autoComplete: "new-password",
          isError: Boolean(errors.password)
        }, register('password', {
          required: '비밀번호를 입력해주세요.',
          minLength: {
            value: 8,
            message: '비밀번호는 최소 8자 이상 입력해주세요.'
          }
        })))]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
        errors: errors,
        name: "password"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Form_LabelText, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "sm-medium",
            children: "\uBE44\uBC00\uBC88\uD638 \uC7AC\uD655\uC778 \xA0"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "sm-medium",
            color: "skyblue_500",
            children: "*\uD544\uC218"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, Form_objectSpread({
          type: "password",
          autoComplete: "new-password",
          isError: Boolean(errors.passwordCheck)
        }, register('passwordCheck', {
          required: '비밀번호 재확인을 입력해주세요.',
          validate: function validate(value) {
            return value === password || '비밀번호가 일치하지 않습니다.';
          }
        })))]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
        errors: errors,
        name: "passwordCheck"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Form_LabelText, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "sm-medium",
            children: "\uD734\uB300\uD3F0 \uBC88\uD638 \xA0"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "sm-medium",
            color: "skyblue_500",
            children: "*\uD544\uC218"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          gap: 8,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, Form_objectSpread(Form_objectSpread({
            type: "text",
            inputMode: "numeric",
            placeholder: "010",
            isError: Boolean(errors.phoneNumber1)
          }, register('phoneNumber1', {
            required: '휴대폰 번호를 입력해주세요.',
            pattern: {
              value: /^01([0|1|6|7|8|9])$/,
              message: '잘못된 휴대폰 번호입니다.'
            }
          })), {}, {
            width: "61px"
          })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, Form_objectSpread(Form_objectSpread({
            type: "text",
            inputMode: "numeric",
            placeholder: "1234",
            isError: Boolean(errors.phoneNumber2)
          }, register('phoneNumber2', {
            required: '휴대폰 번호를 입력해주세요.',
            pattern: {
              value: /^[0-9]{3,4}$/,
              message: '잘못된 휴대폰 번호입니다.'
            }
          })), {}, {
            width: "113.5px"
          })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, Form_objectSpread(Form_objectSpread({
            type: "text",
            inputMode: "numeric",
            placeholder: "5678",
            isError: Boolean(errors.phoneNumber3)
          }, register('phoneNumber3', {
            required: '휴대폰 번호를 입력해주세요.',
            pattern: {
              value: /^[0-9]{4}$/,
              message: '잘못된 휴대폰 번호입니다.'
            }
          })), {}, {
            width: "113.5px"
          }))]
        })]
      }), getPhoneNumberErrorMessage()]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Form_LabelText, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "sm-medium",
            children: "\uC5B4\uB514\uC5D0\uC11C \uC138\uC77C\uC988\uD074\uB8E8\uB97C \uC54C\uAC8C \uB418\uC168\uB098\uC694? \xA0"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "sm-medium",
            color: "skyblue_500",
            children: "*\uD544\uC218"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Select, Form_objectSpread(Form_objectSpread({}, register('acquisitionPath', {
          required: '유입경로를 선택해주세요.'
        })), {}, {
          isError: Boolean(errors.acquisitionPath),
          textVariant: "sm-medium",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
            value: "",
            children: "-- \uC120\uD0DD\uD558\uC138\uC694 --"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
            value: "\uAC80\uC0C9\uC5D4\uC9C4",
            children: "\uAC80\uC0C9\uC5D4\uC9C4(\uAD6C\uAE00/\uB124\uC774\uBC84)"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
            value: "\uBE14\uB85C\uADF8",
            children: "\uBE14\uB85C\uADF8"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
            value: "SNS",
            children: "SNS(\uC2A4\uB808\uB4DC/\uB9C1\uD06C\uB4DC\uC778)"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
            value: "\uC9C0\uC778 \uCD94\uCC9C",
            children: "\uC9C0\uC778 \uCD94\uCC9C"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
            value: "\uAD11\uACE0",
            children: "\uAD11\uACE0"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
            value: "\uAE30\uD0C0",
            children: "\uAE30\uD0C0"
          })]
        }))]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
        errors: errors,
        name: "acquisitionPath"
      })]
    }), acquisitionPath === '기타' && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      style: {
        marginTop: 8
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Form_LabelText, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "sm-medium",
            children: "\uAE30\uD0C0 \uC720\uC785\uACBD\uB85C"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, Form_objectSpread({
          type: "text",
          placeholder: "ex) \uCEE4\uBBA4\uB2C8\uD2F0 \uC774\uB984, \uC9C0\uC778 \uC774\uB984 \uB4F1"
        }, register('acquisitionPathEtc', {
          required: '기타 유입경로를 입력해주세요.'
        })))]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
        errors: errors,
        name: "acquisitionPathEtc"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Form_LabelText, {
          children: "\uD68C\uC0AC"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, Form_objectSpread({
          type: "text",
          placeholder: "ex) \uC8FC\uC2DD\uD68C\uC0AC \uC138\uC77C\uC988\uD074\uB8E8",
          isError: Boolean(errors.company)
        }, register('company')))]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Form_LabelText, {
          children: "\uC9C1\uCC45"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, Form_objectSpread({
          type: "text",
          placeholder: "ex) \uC138\uC77C\uC988 \uB9AC\uB4DC"
        }, register('position')))]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignUp_CheckBox, {
      register: register,
      setValue: setValue,
      getValues: getValues
    }), signUpErrorMessage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      as: "p",
      color: "cerise_300",
      variant: "sm-regular",
      marginTop: 8,
      children: signUpErrorMessage
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
      type: "submit",
      variant: "skyblue_400_fill",
      textVariant: "lg-regular",
      width: "304px",
      radius: 4,
      paddingY: 12,
      disabled: !isAuthCodeChecked || !isValid,
      children: "\uD68C\uC6D0\uAC00\uC785 \uC644\uB8CC"
    })]
  });
};

/* harmony default export */ var SignUp_Form = (Form);
;// CONCATENATED MODULE: ./components/SignUp/index.styles.ts


function SignUp_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var index_styles_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e159e1hb1"
} : 0)( true ? {
  name: "xc7k8z",
  styles: "display:flex;flex-direction:column;align-items:center;padding-bottom:180px;margin:96px auto 24px;gap:24px"
} : 0);
var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Text */.xv,  true ? {
  target: "e159e1hb0"
} : 0)( true ? {
  name: "255c6r",
  styles: "word-break:keep-all"
} : 0);
;// CONCATENATED MODULE: ./components/SignUp/PolicyLinks/index.tsx






var PolicyLinks = function PolicyLinks() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
      href: URLS.privacyPolicyPage,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          as: "p",
          color: "zinc_400",
          variant: "sm-regular",
          textAlign: "center",
          children: "\uAC1C\uC778\uC815\uBCF4 \uCC98\uB9AC \uBC29\uCE68"
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
      href: URLS.termsOfServicePage,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          as: "p",
          color: "zinc_400",
          variant: "sm-regular",
          marginTop: 8,
          textAlign: "center",
          children: "\uC774\uC6A9 \uC57D\uAD00"
        })
      })
    })]
  });
};

/* harmony default export */ var SignUp_PolicyLinks = (PolicyLinks);
;// CONCATENATED MODULE: ./components/SignUp/index.tsx










var SignUp = function SignUp() {
  var isMobile = (0,react_responsive.useMediaQuery)({
    maxWidth: 767
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Main/* default */.Z, {
    isMobile: isMobile,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_styles_Wrapper, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Title, {
        as: "h1",
        variant: "3xl-semibold",
        textAlign: "center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "xl-medium",
          textAlign: "center",
          children: "\uAC04\uB2E8\uD55C \uC815\uBCF4 \uC785\uB825 \uD6C4,"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uACE0\uAC1D \uB9C8\uC74C \uC54C\uC544\uBCF4\uAE30\uB97C \uC2DC\uC791\uD569\uB2C8\uB2E4!"]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
        as: "p",
        color: "zinc_400",
        variant: "md-regular",
        textAlign: "center",
        children: ["\uC785\uB825\uD558\uC2E0 \uC815\uBCF4\uB294", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uD68C\uC6D0\uAC00\uC785 \uC644\uB8CC \uD6C4 \uC548\uC804\uD558\uAC8C \uC800\uC7A5\uB429\uB2C8\uB2E4."]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignUp_Form, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "/login",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            as: "p",
            variant: "md-bold",
            color: "skyblue_400",
            textAlign: "center",
            children: "\uC774\uBBF8 \uAC00\uC785\uD558\uC168\uB098\uC694? \uB85C\uADF8\uC778\uD558\uAE30"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignUp_PolicyLinks, {})]
    })
  });
};

/* harmony default export */ var components_SignUp = (SignUp);
;// CONCATENATED MODULE: ./pages/signup.tsx



var SignUpPage = function SignUpPage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_SignUp, {});
};

/* harmony default export */ var signup = (SignUpPage);

/***/ }),

/***/ 90492:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup",
      function () {
        return __webpack_require__(53839);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6577,7160,3501,4331,9774,2888,179], function() { return __webpack_exec__(90492); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);